import React from "react"
// import ReactDOM from "react-dom"
import {ThemeProvider, Theme} from "@mui/material/styles"
import {nextMaterialUITheme} from "@next/themes"
import Plp from "./compositions/plp"
import {globalStyle} from "./GlobalStyle"
import {IS_BROWSER} from "./utils/window"
import {FeatureSettingsContext} from "./contexts/FeatureSettingsContext"

export interface AppProps {
    isConfError: boolean
    appScope?: string
    themeColours?: Theme
    // eslint-disable-next-line react/no-unused-prop-types
    realm: string
    textAlignment: Theme["direction"]
    themeVersion: string
    enablingCenteredContent: boolean
    launchDarklySettings: any
}

export const App: React.FC<AppProps> & any = (props: AppProps) => {
    // Can not use isOnClient here because props.themeColours does not exist on the client
    const colours = IS_BROWSER() ? (window as any).themeColours[props.themeVersion] : props.themeColours

    const theme = {
        ...nextMaterialUITheme(colours, props.textAlignment || "ltr"),
        colours,
        enablingCenteredContent: props.enablingCenteredContent,
    }

    return (
        <ThemeProvider theme={theme}>
            {globalStyle}
            {props.isConfError ? (
                <div data-testid="error" className="x-next-plat-mod">
                    CONF_ERROR
                </div>
            ) : (
                <div id="platform_modernisation_plp" className="platform_modernisation_plp x-next-plat-mod">
                    <FeatureSettingsContext.Provider value={props.launchDarklySettings}>
                        <Plp />
                    </FeatureSettingsContext.Provider>
                </div>
            )}
        </ThemeProvider>
    )
}

export default App
